import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import Input from "@react/shared/ui/Input"

const sortPresets = () => [
  { label: I18n.t("quotes.qline_service_blueprints.toolbar.sort_recently_updated"), order: "quotes_qline_service_blueprints.updated_at", direction: "desc" },
  { label: I18n.t("quotes.qline_service_blueprints.toolbar.sort_oldest"),           order: "quotes_qline_service_blueprints.updated_at", direction: "asc"  },
  { label: I18n.t("quotes.qline_service_blueprints.toolbar.sort_name_asc"),         order: "quotes_qline_service_blueprints.name",       direction: "asc"  },
  { label: I18n.t("quotes.qline_service_blueprints.toolbar.sort_name_desc"),        order: "quotes_qline_service_blueprints.name",       direction: "desc" },
]

const serializePreset = preset => `${preset.order}|${preset.direction}`

const Toolbar = ({ search, onSearchChange, order, direction, onSortChange }) => {
  const currentPreset = `${order}|${direction}`

  const handleSortSelect = event => {
    const [nextOrder, nextDirection] = event.target.value.split("|")
    onSortChange(nextOrder, nextDirection || "desc")
  }

  return (
    <div className="flex items-center gap-3 p-3 border-b border-slate-200">
      <div className="flex-1 max-w-md">
        <Input
          variant     = "search"
          leadingIcon = "magnifying-glass"
          value       = {search}
          onChange    = {event => onSearchChange(event.target.value)}
          placeholder = {I18n.t("quotes.qline_service_blueprints.toolbar.search_placeholder")}
        />
      </div>

      <div className="flex-1" />

      <div className="relative">
        <select
          value     = {currentPreset}
          onChange  = {handleSortSelect}
          className = "appearance-none h-9 pl-3 pr-8 rounded-md border border-slate-200 text-sm bg-white"
        >
          {sortPresets().map(preset => (
            <option key={serializePreset(preset)} value={serializePreset(preset)}>
              {preset.label}
            </option>
          ))}
        </select>
        <FontAwesomeIcon
          icon      = "chevron-down"
          className = "absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-400 text-[10px] pointer-events-none"
        />
      </div>
    </div>
  )
}

export default Toolbar
